var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "div",
        {
          attrs: { id: "mentions-popup-container" },
          on: { click: _vm.containerClick, contextmenu: _vm.containerClick },
        },
        [
          _c(
            "div",
            { staticClass: "mentions-popup" },
            [
              _c("div", { staticClass: "mentions-popup-title" }, [
                _vm._v("\n\t\t\tRecent mentions\n\t\t\t"),
                _vm.resolvedMessages.length
                  ? _c(
                      "button",
                      {
                        staticClass: "btn dismiss-all-mentions",
                        on: {
                          click: function ($event) {
                            return _vm.dismissAllMentions()
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\tDismiss all\n\t\t\t")]
                    )
                  : _vm._e(),
              ]),
              _vm.resolvedMessages.length === 0
                ? [
                    _vm.isLoading
                      ? _c("p", [_vm._v("Loading…")])
                      : _c("p", [_vm._v("You have no recent mentions.")]),
                  ]
                : _vm._l(_vm.resolvedMessages, function (message) {
                    return [
                      _c(
                        "div",
                        { key: message.msgId, class: ["msg", message.type] },
                        [
                          _c("div", { staticClass: "mentions-info" }, [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "from" },
                                [
                                  _c("Username", {
                                    attrs: { user: message.from },
                                  }),
                                  message.channel
                                    ? [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\tin " +
                                            _vm._s(
                                              message.channel.channel.name
                                            ) +
                                            " on\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              message.channel.network.name
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    : [_vm._v(" in unknown channel ")],
                                ],
                                2
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "time",
                                  attrs: { title: message.localetime },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.messageTime(message.time)) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "close-tooltip tooltipped tooltipped-w",
                                  attrs: {
                                    "aria-label": "Dismiss this mention",
                                  },
                                },
                                [
                                  _c("button", {
                                    staticClass: "msg-dismiss",
                                    attrs: {
                                      "aria-label": "Dismiss this mention",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dismissMention(message)
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "content", attrs: { dir: "auto" } },
                            [
                              _c("ParsedMessage", {
                                attrs: { network: null, message: message },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }